<div class="shield-box">
  <ng-container *ngIf="currentAccount?.kind !== '3a'; else pillarGuarantee">
    <span class="icon-i-shield-checkmark"></span>
    <p>
      {{ 'protected' | translate }} <a (click)="openGuaranteeModal()" class="blue">{{ 'learn_more' | translate }}.</a>
    </p>
  </ng-container>
  <ng-template #pillarGuarantee>
    <img class="pillar-3a" src="/assets/images/shield-liberty.svg" alt="shield" />
    <p class="pillar-3a" [innerHTML]="'protected-3a' | translate"></p>
  </ng-template>
</div>
